import * as Models from 'contracts/models';

export const Endpoint = () => `/api/v3/admin/organizations/`;
export const QueryKey = () => ['v3', 'admin', 'organizations'] as const;
export type Payload = never;
export type Response = Models.Organizations.Organization[];
